import { provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Routes } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { provideFormFactoryConfig } from 'ngx-dynamic-forms-factory';
import icons from './icons';

export interface CoreOptions {
  routes: Routes;
}

export function provideCore({ routes }: CoreOptions) {
  return [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideFormFactoryConfig({
      grid: {
        mainGridClassess: 'grid grid-cols-12 gap-x-4 gap-y-2',
        nestedGridClassess: 'grid grid-cols-12 gap-x-4 gap-y-2',
      },
    }),
    provideIcons(icons),
  ];
}
